import React from 'react';
import cx from 'classnames';
import styles from './styles.module.scss';
import {Text} from '@priority-software/priority-style-react';

type Props = {
    className?: string;
    text?: string;
    color?: string;
    emptyType?: boolean;
};

export const Point = ({text, color, emptyType, className}: Props) => {
    const style = emptyType
        ? {borderColor: color, backgroundColor: 'transparent', '--arrow-color': color}
        : {backgroundColor: color, borderColor: color, color: '#fff', '--arrow-color': color};
    return (
        <div className={cx(styles.container, className)} style={style}>
            <Text skin="paragraph-1" componentClasses={styles.text}>
                {text}
            </Text>
        </div>
    );
};
